const SNACKBAR_VARIANT_SHEET = 'SnackbarVariant';
const FORM_TAB_SHEET = 'FormTab';
const IMAGE_DROPZONE_SHEET = 'ImageDropzone';
const CONFIRMATION_SUMMARY_DIALOG_SHEET = 'ConfirmationSummaryDialog';
const SIDE_MENU_DRAWER_SHEET = 'SideMenuDrawer';
const SIDE_MENU_FOOTER_SHEET = 'SideMenuFooter';
const EMPTY_STATE_SHEET = 'EmptyState';
const EVENT_CARD_SHEET = 'EventCard';
const EVENT_GROUP_CARD_SHEET = 'EventGroupCard';
const EVENT_GROUP_SUBSCRIPTIONS_SHEET = 'EventGroupSubscriptions';
const TEMPLATE_CARD_SHEET = 'TemplateCard';
const TEMPLATE_DESIGNER_SHEET = 'TemplateDesigner';
const EDIT_CANVAS_LAYOUT_SHEET = 'EditCanvasLayout';
const USER_SETTINGS_SHEET = 'UserSettings';
const PAGE_GRID_SHEET = 'BackofficePageGrid';
const SEARCH_FORM_SHEET = 'SearchForm';
const EXAMINER_PAIRING_PAGE_SHEET = 'ExaminerPairingPage';
const EVENT_IMAGE_PAGE_SHEET = 'EventImagePage';
const EVENT_IMAGE_SHEET = 'EventImage';
const EVENT_RESET_SHEET = 'EventReset';
const CONNECTION_MARK_SHEET = 'AdvertisementConnectionMark';
const WIDGET_COLOR_INPUT_SHEET = 'WidgetColorInput';
const EVENT_SALES_SHEET = 'EventOverviewSales';
const ITEM_HEADER_SHEET = 'ItemHeader';
const DESCRIPTION_EDITOR_SHEET = 'DescriptionEditor';
const ADDRESS_SUGGESTIONS_SHEET = 'AddressSuggestions';
const SELECT_FIELD_SHEET = 'SelectField';
const FORM_TEXT_FIELD_SHEET = 'FormTextField';
const DATE_RANGE_DISCLAIMER_SHEET = 'DateRangeDisclaimer';
const INFO_ICON_SHEET = 'InfoIcon';
const EVENT_LOCATION_SHEET = 'EventLocation';
const PRICE_FORM_SHEET = 'PriceForm';
const TICKETS_COUNT_SLIDER_SHEET = 'TicketsCountSlider';
const ITEM_FORM_DETAILS_SHEET = 'ItemFormDetails';
const ADD_ON_IMAGE_FIELD_SHEET = 'AddOnImageField';
const STATUS_BADGE_SHEET = 'StatusBadge';
const OPTION_FIELD_SHEET = 'OptionField';
const TOKEN_FIELD_SHEET = 'TokenField';
const TICKET_TYPES_SELECTOR_SHEET = 'TicketTypesSelector';
const TICKET_DESIGN_BLOCK_SHEET = 'TicketDesignBlock';
const DESIGN_PICKER_SHEET = 'DesignPicker';
const ARTWORK_DROPZONE_SHEET = 'ArtworkDropzone';
const DESIGN_PREVIEW_PANEL_SHEET = 'DesignPreviewPanel';
const SEARCH_BLOCK_SHEET = 'SearchBlock';
const BUYER_EVENT_CARD_SHEET = 'BuyerEventCard';
const BUYER_SUBSCRIPTION_CARD_SHEET = 'BuyerSubscriptionCard';
const BUYER_SUBSCRIPTION_STATUS_SHEET = 'BuyerSubscriptionStatus';
const DESTRUCTIVE_ACTION_SHEET = 'DestructiveAction';
const POINTS_OF_SALE_MENU_SHEET = 'PointsOfSaleMenu';
const POINTS_OF_SALE_ACTIONS_SHEET = 'PointsOfSaleActions';

export {
    SNACKBAR_VARIANT_SHEET,
    FORM_TAB_SHEET,
    IMAGE_DROPZONE_SHEET,
    CONFIRMATION_SUMMARY_DIALOG_SHEET,
    SIDE_MENU_DRAWER_SHEET,
    SIDE_MENU_FOOTER_SHEET,
    EMPTY_STATE_SHEET,
    EVENT_CARD_SHEET,
    EVENT_GROUP_CARD_SHEET,
    EVENT_GROUP_SUBSCRIPTIONS_SHEET,
    TEMPLATE_CARD_SHEET,
    TEMPLATE_DESIGNER_SHEET,
    EDIT_CANVAS_LAYOUT_SHEET,
    USER_SETTINGS_SHEET,
    PAGE_GRID_SHEET,
    SEARCH_FORM_SHEET,
    EXAMINER_PAIRING_PAGE_SHEET,
    EVENT_IMAGE_PAGE_SHEET,
    EVENT_IMAGE_SHEET,
    EVENT_RESET_SHEET,
    CONNECTION_MARK_SHEET,
    WIDGET_COLOR_INPUT_SHEET,
    EVENT_SALES_SHEET,
    ITEM_HEADER_SHEET,
    DESCRIPTION_EDITOR_SHEET,
    ADDRESS_SUGGESTIONS_SHEET,
    SELECT_FIELD_SHEET,
    FORM_TEXT_FIELD_SHEET,
    DATE_RANGE_DISCLAIMER_SHEET,
    INFO_ICON_SHEET,
    EVENT_LOCATION_SHEET,
    PRICE_FORM_SHEET,
    TICKETS_COUNT_SLIDER_SHEET,
    ITEM_FORM_DETAILS_SHEET,
    ADD_ON_IMAGE_FIELD_SHEET,
    STATUS_BADGE_SHEET,
    OPTION_FIELD_SHEET,
    TOKEN_FIELD_SHEET,
    TICKET_TYPES_SELECTOR_SHEET,
    TICKET_DESIGN_BLOCK_SHEET,
    DESIGN_PICKER_SHEET,
    ARTWORK_DROPZONE_SHEET,
    DESIGN_PREVIEW_PANEL_SHEET,
    SEARCH_BLOCK_SHEET,
    BUYER_EVENT_CARD_SHEET,
    BUYER_SUBSCRIPTION_CARD_SHEET,
    BUYER_SUBSCRIPTION_STATUS_SHEET,
    DESTRUCTIVE_ACTION_SHEET,
    POINTS_OF_SALE_MENU_SHEET,
    POINTS_OF_SALE_ACTIONS_SHEET,
};
